import script from "./StoryTitle.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./StoryTitle.vue?vue&type=script&lang=js"
export * from "./StoryTitle.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./StoryTitle.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"src/SharedWeb/scripts/dynamic-component-editor/standard-pages/story-page/StoryTitle.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "63f9e804"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('63f9e804', __exports__)) {
    api.reload('63f9e804', __exports__)
  }
  
}


export default __exports__